/** Small, consistent 16px stroke icons. Used sparingly: navigation and actions only. */
import type { SVGProps } from 'react';

type P = SVGProps<SVGSVGElement> & { size?: number };
const base = (size = 16): SVGProps<SVGSVGElement> => ({
  width: size,
  height: size,
  viewBox: '0 0 16 16',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
});

export const IconHome = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M2.5 7 8 2.5 13.5 7v6.5h-4v-4h-3v4h-4z" /></svg>
);
export const IconUsers = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><circle cx="6" cy="5.5" r="2.5" /><path d="M1.5 13.5c.4-2.3 2.2-3.6 4.5-3.6s4.1 1.3 4.5 3.6" /><path d="M10.5 3.2a2.4 2.4 0 0 1 0 4.6M12.3 9.9c1.2.5 2 1.8 2.2 3.6" /></svg>
);
export const IconFile = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M4 1.5h5.5L13 5v9.5H4z" /><path d="M9.5 1.5V5H13M6 8.5h5M6 11h5" /></svg>
);
export const IconReceipt = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M3.5 1.5h9v13l-1.8-1.2-1.5 1.2-1.7-1.2-1.7 1.2-1.5-1.2-1.8 1.2z" /><path d="M6 5h4M6 7.5h4M6 10h2.5" /></svg>
);
export const IconInbox = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M1.5 9 3.5 3h9l2 6v4.5h-13z" /><path d="M1.5 9h4l1 1.8h3l1-1.8h4" /></svg>
);
export const IconCash = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><rect x="1.5" y="4" width="13" height="8" rx="1" /><circle cx="8" cy="8" r="1.8" /><path d="M4 6.5v3M12 6.5v3" /></svg>
);
export const IconBolt = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M9 1.5 3.5 9H8l-1 5.5L12.5 7H8z" /></svg>
);
export const IconSettings = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><circle cx="8" cy="8" r="2" /><path d="M8 1.5v1.7M8 12.8v1.7M1.5 8h1.7M12.8 8h1.7M3.4 3.4l1.2 1.2M11.4 11.4l1.2 1.2M3.4 12.6l1.2-1.2M11.4 4.6l1.2-1.2" /></svg>
);
export const IconSearch = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><circle cx="7" cy="7" r="4.5" /><path d="m10.5 10.5 3.5 3.5" /></svg>
);
export const IconPlus = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M8 3v10M3 8h10" /></svg>
);
export const IconUpload = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M8 10.5V2.5M5 5.5l3-3 3 3M2.5 10.5v3h11v-3" /></svg>
);
export const IconDownload = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M8 2.5v8M5 7.5l3 3 3-3M2.5 10.5v3h11v-3" /></svg>
);
export const IconExternal = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M9 2.5h4.5V7M13.5 2.5 7.5 8.5M11.5 9.5v4h-9v-9h4" /></svg>
);
export const IconX = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="m4 4 8 8M12 4l-8 8" /></svg>
);
export const IconCheck = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="m3 8.5 3 3 7-7" /></svg>
);
export const IconAlert = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M8 1.8 14.5 13.5h-13z" /><path d="M8 6.5v3M8 11.6v.1" /></svg>
);
export const IconMail = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><rect x="1.5" y="3" width="13" height="10" rx="1" /><path d="m2 4 6 5 6-5" /></svg>
);
export const IconLogout = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M6 2.5H2.5v11H6M10.5 5l-3 3 3 3M7.5 8h7" /></svg>
);
export const IconMenu = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M2 4h12M2 8h12M2 12h12" /></svg>
);
export const IconChevron = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="m10 3-5 5 5 5" /></svg>
);
export const IconRefresh = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M13.5 3v3.5H10M2.5 13v-3.5H6" /><path d="M3.3 6.2A5 5 0 0 1 12.9 6M12.7 9.8A5 5 0 0 1 3.1 10" /></svg>
);
export const IconTrash = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M2.5 4h11M6 4V2.5h4V4M4 4l.7 9.5h6.6L12 4" /></svg>
);
export const IconStar = ({ size, filled, ...p }: P & { filled?: boolean }) => (
  <svg {...base(size)} fill={filled ? 'currentColor' : 'none'} {...p}><path d="m8 1.8 1.9 3.9 4.3.6-3.1 3 .7 4.3L8 11.6l-3.8 2 .7-4.3-3.1-3 4.3-.6z" /></svg>
);
export const IconChecklist = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="m2 4 1.2 1.2L5.5 3M2 9.5l1.2 1.2L5.5 8.5M8 4.2h6M8 9.7h6M8 13.5h6" /></svg>
);
export const IconTarget = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><circle cx="8" cy="8" r="6" /><circle cx="8" cy="8" r="3.2" /><circle cx="8" cy="8" r=".6" fill="currentColor" /></svg>
);
export const IconRepeat = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M3 7V6a2.5 2.5 0 0 1 2.5-2.5H13m0 0-2-2m2 2-2 2M13 9v1a2.5 2.5 0 0 1-2.5 2.5H3m0 0 2 2m-2-2 2-2" /></svg>
);
export const IconMerge = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><circle cx="4" cy="3" r="1.5" /><circle cx="4" cy="13" r="1.5" /><circle cx="12" cy="8" r="1.5" /><path d="M4 4.5v7M4 6c0 2 2 2 6.5 2" /></svg>
);
export const IconTruck = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M1.5 4h8v7h-8zM9.5 6.5h2.8L14.5 9v2h-5" /><circle cx="4.2" cy="12" r="1.3" /><circle cx="11.8" cy="12" r="1.3" /></svg>
);
export const IconPrinter = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M4.5 6V2h7v4M4.5 11.5h-2V6.5h11v5h-2M4.5 9.5h7V14h-7z" /></svg>
);
export const IconPhone = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M3.2 2h2.3l1 2.8-1.4 1a7.5 7.5 0 0 0 3.1 3.1l1-1.4 2.8 1v2.3A1.3 1.3 0 0 1 10.7 12 9.2 9.2 0 0 1 2 3.3 1.3 1.3 0 0 1 3.2 2z" /></svg>
);
export const IconBox = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M8 1.8 13.8 4.6v6.8L8 14.2 2.2 11.4V4.6zM2.2 4.6 8 7.4l5.8-2.8M8 7.4v6.8" /></svg>
);
export const IconLink = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M6.8 9.2a2.6 2.6 0 0 0 3.7 0l2.2-2.2a2.6 2.6 0 0 0-3.7-3.7l-.9.9M9.2 6.8a2.6 2.6 0 0 0-3.7 0L3.3 9a2.6 2.6 0 0 0 3.7 3.7l.9-.9" /></svg>
);
export const IconTrend = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M2 12.5 6 8.5l2.5 2.5L14 5.5M10.5 5.5H14V9" /></svg>
);
export const IconCart = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}><path d="M1.5 2.5h2l1.6 7.5h7.4l1.5-5.5H4.3" /><circle cx="6.2" cy="12.8" r="1" /><circle cx="11.6" cy="12.8" r="1" /></svg>
);
